module.exports = __webpack_public_path__ + "static/Trusted Shops-4d2342b0676c927bec9ad2af48f082c6.svg";